import './Page.scss';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { Link } from 'react-router-dom';
import Box from 'src/components/Box';
import Breadcrumb from 'src/components/Breadcrumb';
import BreadcrumbItem from 'src/components/Breadcrumb/BreadcrumbItem';
import Title from 'src/components/Title';
import Wrapper from 'src/components/Wrapper';
import { usePageNode } from 'src/context/pages';
import { IPageNode } from 'src/context/pages/types';
import PageNotFound from 'src/Pages/PageNotFound';

interface IPageRouteProps {
  slug: string;
}

const Page = ({ match }: RouteComponentProps<IPageRouteProps>) => {
  const { page, error } = usePageNode(match.params.slug);

  const trail: IPageNode[] = React.useMemo(() => {
    if (!page) {
      return [];
    }

    let currentNode: typeof page = page;
    const pages: Array<typeof page> = [];
    while (currentNode) {
      pages.push(currentNode);
      if (!currentNode.parentNode) {
        break;
      }
      currentNode = currentNode.parentNode;
    }
    return pages.reverse();
  }, [page]);

  if (error) {
    return <PageNotFound />;
  }

  if (page) {
    return (
      <div className="has-background-gray-body pb-14">
        <Wrapper>
          <Breadcrumb className="pt3">
            <BreadcrumbItem>
              <Link to="/">Forside</Link>
            </BreadcrumbItem>
            {trail.map((node, index) => (
              <BreadcrumbItem
                key={node.portalPageId}
                active={index === trail.length - 1}
              >
                <Link to={`/sider/${node.slug}`}>{node.title}</Link>
              </BreadcrumbItem>
            ))}

          </Breadcrumb>
          <Title className="my-4">{page.title}</Title>

          <div className="PageContent p-14 has-background-white" dangerouslySetInnerHTML={{ __html: page.content }} />
        </Wrapper>
      </div>
    );
  }

  return (
    <div className="has-background-gray-body pb-14" />
  );
}
export default Page;



// WEBPACK FOOTER //
// ./src/Pages/CoursePortal/Page/index.tsx